
import React from 'react'

import {BrowserRouter as Router, Routes,Route} from 'react-router-dom'

import Home from './components/Home';
import Game from './components/Game';
import Einde from './components/Einde'


import {GlobalStyle} from './GlobalStyle';


// const knoppies = [{"tafel":1},{"tafel":2},{"tafel":3},{"tafel":4},{"tafel":5}
//   ,{"tafel":6},{"tafel":7},{"tafel":8},{"tafel":9},{"tafel":10}
//     ,{"tafel":11},{"tafel":12}];

const App = () => {

//   return(
//     <div className='App'>
//         <Home/>
//         <GlobalStyle/>

//     </div>

// )
 
return(

  <div>
  <Router>
      <Routes>  
        <Route path='/' element={<Home/>}/>
        <Route path='/:Game' element={<Game/>}/>
        <Route path='/:Game/:Einde' element={<Einde/>}/>

      </Routes>
    
    <GlobalStyle/>

    </Router>

  </div>


 )

      


}

export default App;
